// Lazy loader for Áskell's embedded checkout SDK (askell.js). The script is
// ~750 KB, so it is only fetched when the subscription modal opens. askell.js
// picks up its companion askell.css from the same directory by itself.

const DEFAULT_ASKELL_JS_URL = 'https://cdn.askell.is/js/dist/askell.js'

let askellPromise = null

export const loadAskell = () => {
  if (window.Askell) {
    return Promise.resolve(window.Askell)
  }
  if (askellPromise) {
    return askellPromise
  }
  askellPromise = new Promise((resolve, reject) => {
    const src = window.ASKELL_JS_URL || DEFAULT_ASKELL_JS_URL
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => {
      if (window.Askell) {
        resolve(window.Askell)
      } else {
        askellPromise = null
        reject(new Error('askell.js loaded but window.Askell is missing'))
      }
    }
    script.onerror = () => {
      askellPromise = null
      script.remove()
      reject(new Error(`Could not load ${src}`))
    }
    document.head.appendChild(script)
  })
  return askellPromise
}

export const currentColorScheme = () => {
  return document.body.classList.contains('dark-mode') ? 'dark' : 'light'
}

export const defaultCurrency = () => {
  if (window.LANGUAGE_CODE === 'is' || window.COUNTRY_CODE === 'IS') {
    return 'ISK'
  }
  return 'USD'
}

export const widgetLanguage = () => {
  return window.LANGUAGE_CODE === 'is' ? 'is' : 'en'
}
